import { getPlayoutDevices } from '@mimir/web/util/api';
import type { PlayoutDeviceDto, PlayoutDeviceStatusGetDto} from '@mimir/common/dto/playoutDtos';
import { samePlayoutDeviceIds } from '@mimir/common/dto/playoutDtos';
import type { PlayoutWsSubscription} from '@mimir/client-common/playout/playoutWs';
import { setPlayoutWsMode } from '@mimir/client-common/playout/playoutWs';
import Vue from 'vue';
import { getGlobalStore, appState } from '@mimir/web/store';
import { canControlPlayout } from '@mimir/common/util/security';

export class PlayoutDevicesHelper {

  playoutDevices: PlayoutDeviceDto[] = [];
  wsSubscription: PlayoutWsSubscription | null = null;
  public loading = true;
  public errorMessage: string | null = null;

  showPlayout() {
    const store = getGlobalStore();
    return store.getters.showPlayoutFeatures && canControlPlayout(store.getters.user.permissions);
  }


  async mounted() {
    if (!this.showPlayout) {
      return;
    }

    try {
      Vue.set(this, 'playoutDevices', await getPlayoutDevices());
      this.loading = false;
    } catch(error) {
      this.loading = false;
      this.errorMessage = 'Error occurred when fetching playout devices, please try again later.';
      console.warn(this.errorMessage, error);
    }

    if (appState.clientWs) {
      this.wsSubscription = setPlayoutWsMode(appState.clientWs, {
        onStatusChange: async (status: PlayoutDeviceStatusGetDto) => this.updateStatus(status),
      });
    }
  }

  private updateStatus(updated: PlayoutDeviceStatusGetDto) {
    const device = this.playoutDevices.find(l => samePlayoutDeviceIds(l.playoutDeviceId, updated.playoutDeviceId));
    if (device) {
      device.state = {
        status: updated.status,
        previewUrl: updated.previewUrl,
        modifiedOn: updated.modifiedOn,
      };
    }
  }

  beforeDestroy() {
    if (this.wsSubscription) {
      this.wsSubscription.cancel();
    }
  }

}
